module.exports = __webpack_public_path__ + "static/media/TableCorner2_Before.0869b525.jpg";